<template>
  <!-- 百才汇 要闻动态 常见问答 -->
  <div class="changjianwenda">
    <!-- 头部 -->
    <Header />
    <div class="changjianwendabox">
      <!-- banner -->
      <div class="bannerimgs">
        <img
          src="../../../assets/images/yaowendongtaiFile/changjianwenda/banner.png"
          alt="百才汇"
        />
      </div>
      <!-- title -->
      <img
        class="titleimg"
        src="../../../assets/images/yaowendongtaiFile/changjianwenda/wendalist_top.png"
        alt="百才汇"
      />
      <!-- 问答列表 -->
      <ul class="wendaOul">
        <li
          class="wendaOli"
          v-for="(item, index) in wendaData"
          :key="index"
          @click="handlewendaClick(item)"
        >
          <img
            src="../../../assets/images/yaowendongtaiFile/changjianwenda/wenda_icon.png"
            alt="百才汇"
          />
          <div class="text">
            {{ item.Extend1 }}
          </div>
        </li>
      </ul>
      <!-- 加载更多 -->
      <a ref="nofollow" class="problem_more" @click="LoadMore">{{ jzTxt }}</a>
    </div>
    <!-- 底部 -->
    <Bottom />
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import Header from "@/P09_BaiCaiHui/components/Header.vue";
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
export default {
  metaInfo() {
    return {
      title: "上海落户常见问题-相关解答-百才汇",
      meta: [
        {
          name: "keywords",
          content: "上海落户常见问题",
        },
        {
          name: "description",
          content:
            "百才汇要闻动态,为您解答上海落户常见问题,相关上海落户政策、规定、条件等信息,您要的答案,都可以在这里找到,更详细的请咨询我们。",
        },
      ],
    };
  },
  components: {
    Header,
    Bottom,
  },
  data() {
    return {
      //问答列表
      wendaData: [],
      //list加载
      jzTxt: "点击加载更多",
      isLoad: true,
      //分页
      pagination: {
        // 总条数
        total: 0,
        // 当前页码
        currentPage: 1,
        // 默认多少条数
        pagesize: 6,
      },
    };
  },
  activated() {},
  mounted() {
    //获取问答列表
    this.getData();
  },
  methods: {
    //初始化问答列表
    getData() {
      this.jzTxt = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 330,
          index: this.pagination.currentPage,
          size: this.pagination.pagesize,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.wendaData = this.wendaData.concat(res.data.Data.list);
            //   // 加载状态结束
            this.jzTxt = "点击加载更多";
            //   // 数据全部加载完成
            if (this.wendaData.length >= res.data.DataCount) {
              this.isLoad = false;
              this.jzTxt = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination.currentPage++;
    },
    //点击问答列表点击进入详情页
    handlewendaClick(item, index) {
      this.$router.push(
        "/wendacontent/" +
          item.WebsiteContentId +
          "-" +
          item.WebsiteMenuId +
          ".html"
      );
    },
    //加载更多
    LoadMore() {
      if (!this.isLoad) return false;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.changjianwenda {
  .changjianwendabox {
    margin-top: 80px;
    margin-bottom: 60px;
    // banner
    .bannerimgs {
      width: 100%;
      height: 200px;
      img {
        width: 100%;
        height: 200px;
      }
    }
    //title
    .titleimg {
      width: 481px;
      height: 36px;
      margin: 60px auto 40px;
      display: block;
    }
    //问答列表
    .wendaOul {
      width: 670px;
      margin: 0 auto;
      .wendaOli {
        display: flex;
        padding: 37px 0;
        border-bottom: 1px solid #dcdcdc;
        img {
          width: 40px;
          height: 39px;
          display: block;
        }
        .text {
          margin-left: 30px;
          width: 599px;
          height: 33px;
          letter-spacing: 1px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .wendaOli:first-child {
        padding-top: 0;
      }
    }
    //加载更多按钮
    /deep/.problem_more {
      display: block;
      font-size: 22px;
      color: #fff;
      background-color: #cbb486;
      height: 60px;
      line-height: 60px;
      text-align: center;
      margin: 0 auto;
      margin-top: 50px;
      width: calc(100% - 60px);
      text-decoration: none;
      border-radius: 8px;
      margin-bottom: 50px;
      letter-spacing: 1px;
    }
  }
}
</style>